import { Component, input, InputSignal, OnInit } from '@angular/core';
import { AssessorCollectorService } from '../../Assessor-Collector/assessor.collector.service';
import { EntityTypeIDs, EntityTypeNames } from '../../constants.new';
import { UIRouter } from '@uirouter/angular';
import { NavigationService } from '../../Layout/navigation.service';
import { AceLoaderComponent } from '../../UI-Lib/ACE/Loader/loader.component';
import { BillClusterService } from '../../Annual-Details/Taxes/bill-cluster.service';
import { ProcessingService } from '../../Processing/processing.service.upgrade';

@Component({
    selector: 'app-redirect',
    template: `<ws-ace-loader></ws-ace-loader>`,
    imports: [AceLoaderComponent],
})
export class RedirectComponent implements OnInit {
    constructor(
        private readonly _uiRouter: UIRouter,
        private readonly _navigationService: NavigationService,
        private readonly _assessorCollectorService: AssessorCollectorService,
        private readonly _billClusterService: BillClusterService,
        private readonly _processingService: ProcessingService,
    ) {}

    entityTypeId: InputSignal<EntityTypeIDs> = input();

    ngOnInit(): void {
        const entityId = parseInt(this._uiRouter.globals.params['entityId'], 10);
        this._navigate(this.entityTypeId(), entityId);
    }

    private _navigate(entityTypeID: EntityTypeIDs, entityID: number): void {
        switch (entityTypeID) {
            case EntityTypeIDs.ASSESSOR:
                this._assessorCollectorService.getNavigationInfo('assessor', entityID).then((info) => {
                    this._uiRouter.stateService.transitionTo(
                        'assessor',
                        {
                            stateId: info.stateID,
                            id: info.assessorID,
                        },
                        { location: 'replace' },
                    );
                });
                break;
            case EntityTypeIDs.COLLECTOR:
                this._assessorCollectorService.getNavigationInfo('collector', entityID).then((info) => {
                    this._uiRouter.stateService.transitionTo(
                        'collector',
                        {
                            stateId: info.stateID,
                            stateCollectorId: info.collectorID,
                        },
                        { location: 'replace' },
                    );
                });
                break;
            case EntityTypeIDs.INVOICE:
                this._navigationService
                    .getNavigationInfo(EntityTypeNames[EntityTypeIDs.INVOICE], entityID)
                    .then((info) => {
                        let route = 'companyInvoice';
                        const config = {
                            companyID: info.companyID,
                            invoiceID: entityID,
                            siteID: null,
                        };
                        if (info.siteID) {
                            route = 'siteInvoice';
                            config.siteID = info.siteID;
                        }
                        this._uiRouter.stateService.transitionTo(route, config, { location: 'replace' });
                    });
                break;
            case EntityTypeIDs.FILINGBATCH:
                this._navigationService.getNavigationInfo('filingBatch', entityID).then((info) => {
                    const config = {
                        companyId: info.companyID,
                        filingBatchId: entityID,
                    };
                    this._uiRouter.stateService.transitionTo('filingBatchDetails', config, { location: 'replace' });
                });
                break;
            case EntityTypeIDs.BILL_CLUSTER:
                this._billClusterService.getBillClusterByID(entityID).then((billCluster) => {
                    this._navigate(EntityTypeIDs.TAX_BILL, billCluster.bills[0].billID);
                });
                break;
            case EntityTypeIDs.ANNUAL_YEAR:
                this._navigationService.getNavigationInfo('AnnualYear', entityID).then((result) => {
                    const config = {
                        annualYearID: entityID,
                        siteId: result.siteID,
                        companyId: result.companyID,
                        parcelId: result.parcelID,
                    };
                    this._uiRouter.stateService.transitionTo('parcel', config, { location: 'replace' });
                });
                break;
            case EntityTypeIDs.ANNUAL_ASSESSMENT:
                this._navigationService.getNavigationInfo('AnnualAssessment', entityID).then((result) => {
                    this._uiRouter.stateService.transitionTo('parcel', {
                        annualAssessmentID: entityID,
                        siteId: result.siteID,
                        companyId: result.companyID,
                        annualYearID: result.annualYearID,
                        parcelId: result.parcelID,
                    });
                });
                break;
            case EntityTypeIDs.PARCEL_FILING:
                this._navigationService.getNavigationInfo('Filing', entityID).then((result) => {
                    this._uiRouter.stateService.transitionTo('parcel', {
                        filingId: entityID,
                        siteId: result.siteID,
                        companyId: result.companyID,
                        annualYearID: result.annualYearID,
                        parcelId: result.parcelID,
                    });
                });
                break;
            default:
                this._processingService.getEntityTree(entityTypeID, entityID, false).then((tree) => {
                    const transitionState = {
                        companyId: tree.subsidiaryCompany.entityId,
                        siteId: tree.site.entityId,
                    };
                    switch (entityTypeID) {
                        case EntityTypeIDs.SITE:
                            this._uiRouter.stateService.transitionTo('site', transitionState, { location: 'replace' });
                            break;
                        case EntityTypeIDs.PARCEL:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        case EntityTypeIDs.ASSESSMENT:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                        annualYearID: tree.annualYear.entityId,
                                        annualAssessmentID: tree.revision.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        case EntityTypeIDs.APPEAL:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                        annualYearID: tree.annualYear.entityId,
                                        annualAssessmentID: tree.revision.entityId,
                                        appealID: tree.appeal.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        case EntityTypeIDs.TAX_BILL:
                        case EntityTypeIDs.PAYMENT:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                        annualYearID: tree.annualYear.entityId,
                                        billClusterID: tree.billCluster.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        case EntityTypeIDs.REFUND:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                        annualYearID: tree.annualYear.entityId,
                                        refundID: tree.refund.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        case EntityTypeIDs.FILING:
                            this._uiRouter.stateService.transitionTo(
                                'parcel',
                                {
                                    ...transitionState,
                                    ...{
                                        parcelId: tree.parcel.entityId,
                                        annualYearID: tree.annualYear.entityId,
                                        filingId: tree.filing.entityId,
                                    },
                                },
                                { location: 'replace' },
                            );
                            break;
                        default:
                            throw new Error('Entity type ID invalid or missing (got: ' + entityTypeID + ')');
                    }
                });
        }
    }
}
